import React from "react";
import { Link } from "react-router-dom";
import SignUpSvg from "../Common/SignUpSvg";
import SignupEmail from "./SignupEmail";

const SignupFullLayout = () => {
  return (
    <section className="signupfulllayout">
      <div className="logo">
        <Link to="#">
          <SignUpSvg />
        </Link>
      </div>
      <div className="signupverify-main">
        <SignupEmail />
        {/* <SignupVerify /> */}
      </div>
    </section>
  );
};
export default SignupFullLayout;
